import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * The one password rule every account surface shares — creation, edit, change and reset alike
 * (PAUL-3373). At least 8 characters, with a lowercase letter, an uppercase letter and a digit.
 *
 * **No special character**, deliberately. `REGEX_PASSWORD` demands one and is still what the dash
 * and flixit surfaces use; asking for it on registration while the reset page did not meant a
 * password accepted in one channel was refused in the other, for the same account.
 *
 * Reports `passwordStrength` rather than `pattern` so every template renders the same error
 * whichever surface the field sits on.
 */
export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    /* An empty field is `required`'s business, not this one's — reporting both puts two messages
       under a field the customer has simply not reached yet. */
    if (!value) {
      return null;
    }

    const strong = /[a-z]/.test(value) && /[A-Z]/.test(value) && /\d/.test(value) && value.length >= 8;

    return strong ? null : { passwordStrength: true };
  };
}
